import React, { createContext, useContext, useEffect } from "react"
import { EventBus, eventbus, EventMap } from "./EventBus"

const bus = eventbus({onError: (e) => {console.log(e)}})
const TheContext = createContext(bus)

export function EventBusProvider(props: any) {
  const { children } = props
  return <TheContext.Provider value={bus}>{children}</TheContext.Provider>
}

export function useEventBus<TEventMap extends EventMap>() {
  const context = useContext(TheContext)
  if (context === undefined) {
    throw new Error("[useEventBus]")
  }
  return context as EventBus<TEventMap>
}

// This is for backward-compatibility with legacy marionette code
export function getEventBus() {
  return bus
}

export function useEventEffect<TEventMap extends EventMap, TKey extends keyof TEventMap>(bus: EventBus<TEventMap>, key: TKey, handler: TEventMap[TKey]) {
  useEffect(() => {
    return bus.on(key, handler)
  }, [])
}
